const state = {
  departments: [],
  scopesOfCare: [],
  priorities: [],
  sqlReport: [],
  sqlReports: []
};
const mutations = {
  SET_DOD_DEPARTMENTS(state, departments) {
    state.departments = departments
  },
  SET_DOD_SCOPES_OF_CARE(state, scopesOfCare) {
    state.scopesOfCare = scopesOfCare
  },
  SET_DOD_PRIORITIES(state, priorities) {
    state.priorities = priorities
  },
  SET_SQL_REPORT(state, report) {
    state.sqlReport = report
  },
  SET_SQL_REPORTS(state, reports) {
    state.sqlReports = reports
  }
};
const getters = {
  getDodDepartments: state => state.departments,
  getDodScopesOfCare: state => state.scopesOfCare,
  getDodPriorities: state => state.priorities,
  getDodSqlReport: state => state.sqlReport,
  getDodSqlReports: state => state.sqlReports
};

export default {
  state,
  mutations,
  getters,
};